<div class="item-tag-wrapper" *ngFor="let tag of tags">
  <v2-row class="item-tag" alignItems="center">
    <v2-center class="abbr-circle">
      <v2-label-small-secondary-text color="white">
        {{ tag.abbreviated }}
      </v2-label-small-secondary-text>
    </v2-center>

    <v2-body-text class="full-text" color="white">
      {{ tag.full }}
    </v2-body-text>
  </v2-row>
</div>
